import { GeoJsonLayer } from '@deck.gl/layers';

const ICON_MAPPING = {
  opal: { x: 0, y: 0, width: 96, height: 96, mask: false },
  garnetgemstone: { x: 96, y: 0, width: 96, height: 96, mask: false },
  gold: { x: 192, y: 0, width: 96, height: 96, mask: false },
  silver: { x: 288, y: 0, width: 96, height: 96, mask: false },
};

const mineralResourcesLayer = () =>
  new GeoJsonLayer({
    id: 'GeoJsonLayer',
    data:
      'https://acolyte-cog.s3.eu-central-1.amazonaws.com/cog/mygeodata_merged.json',

    /* props from GeoJsonLayer class */

    getElevation: 30,
    // getFillColor: [160, 160, 180, 200],
    // getIconAngle: 0,
    // getIconColor: [0, 0, 0, 255],
    // getIconPixelOffset: [0, 0],
    getIconSize: 1,
    getIcon: ({ properties }) => properties.commodity,
    iconAtlas:
      'https://acolyte-cog.s3.eu-central-1.amazonaws.com/cog/icon-bank.png',
    // iconBillboard: true,
    iconMapping: ICON_MAPPING,
    // iconSizeMaxPixels: Number.MAX_SAFE_INTEGER,
    iconSizeMinPixels: 15,
    iconSizeScale: 0.5,
    iconSizeUnits: 'pixels',
    pointRadiusUnits: 'pixels',
    pointType: 'icon',
    pickable: true,
  });

export { mineralResourcesLayer };
